import {useScopeTranslation} from '@uigstudio/uig-nextjs-helper';

import {Section, SectionName, TextButton} from './styles';

export const closeSearchResults = () =>
    (document.activeElement as HTMLElement)?.blur();

type ResultsProps = {
    sectionName: 'plot' | 'partner';
    data: SearchItem[] | undefined | null;
    onClick: (item: SearchItem) => void;
    handleSearch: (text: string) => void;
};

export type SearchItem = {
    id: number;
    text: string;
};

export const Results = ({
    sectionName,
    onClick,
    data,
    handleSearch,
}: ResultsProps) => {
    const t = useScopeTranslation('common', 'filters', 'search');

    if (!data || !data.length) {
        return null;
    }
    return (
        <Section>
            <SectionName>{t(`searchBy.${sectionName}.sectionName`)}</SectionName>
            {data.slice(0, 10).map((item) => (
                <TextButton
                    key={item.id}
                    onClick={() => {
                        handleSearch(item.text);
                        closeSearchResults();
                        onClick(item);
                    }}
                >
                    {item.text}
                </TextButton>
            ))}
        </Section>
    );
};
